import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { FGrid } from '../grid';
import { ForecastMoneyCell, ForecastVarianceCell, ForecastPercentCell, ForecastConfidenceCell, ForecastStatusChip, ForecastDeltaClass, ForecastGridSx } from './ForecastGridRenderers';

type Props = { rows:any[]; loading?:boolean; selectedId?:any; onSelect?:(row:any)=>void };

class ForecastBatchGrid extends React.PureComponent<Props> {
  columns: GridColDef[] = [
    { field: 'batchcode', headerName: 'Batch Code', width: 170 },
    { field: 'fiscalyear', headerName: 'Fiscal Year', width: 120 },
    { field: 'scenariocode', headerName: 'Scenario', width: 150 },
    { field: 'filename', headerName: 'File', width: 260, flex: 1, minWidth: 260 },
    { field: 'sheetcount', headerName: 'Sheets', width: 100, type: 'number' },
    { field: 'factcount', headerName: 'Facts', width: 110, type: 'number' },
    { field: 'status', headerName: 'Status', width: 140, renderCell: ForecastStatusChip },
    { field: 'created', headerName: 'Created', width: 180 },
  ];

  getRowId = (row:any) => row.rid || row.recid || row.id || row.batchid || row.batchcode;

  render() {
    return (
      <FGrid
        title="Forecast Batches"
        subtitle="Uploaded forecast workbooks and processing batches."
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={360}
        showQuickFilter
        toolbarSx={{ backgroundColor: '#eaf2fb' }}
        getRowId={this.getRowId}
        onRowClick={(p:any) => this.props.onSelect?.(p.row)}
        pageSizeOptions={[10,25,50]}
        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        sx={ForecastGridSx}
      />
    );
  }
}

export default ForecastBatchGrid;
